<template>
  <div class="member-table">    
    <ul class="tabBtns">
      <li 
      :class="authorizationStatues==item.value?'on':''"
      v-for="(item,index) in btns" 
      :key="index" 
      @click="handlerChange(item)">
      {{item.label}}
      </li>      
    </ul>
    <div class="table-header table-row">
      <div class="item">姓名</div>
      <div class="item">手机</div>
      <div class="item email-item">邮箱</div>
      <div class="item">操作</div>
    </div>
    <div class="table-data table-row" v-for="{mobile, realName, email, id} in (infoList.find(v=>v.authorizationStatus==authorizationStatues)||{})['customers']" :key="id">
      <div class="item">{{realName}}</div>
      <div class="item">{{mobile | formatPhoneNumber}}</div>
      <div class="item email-item">{{email}}</div>
      <div class="item btn-item">
        <div class="auth-btn" @click="() => $emit('itemClick', id,'AUTHED',source,authorizationStatues)" v-if="['UN_AUTH'].includes(authorizationStatues)">授权</div>
        <div class="auth-btn" @click="() => $emit('itemClick', id,'CANCEL',source,authorizationStatues)" v-if="['UN_AUTH','AUTHED'].includes(authorizationStatues)">取消授权</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infoList: {
      type: Array,
      default: () => []
    },
    source:{
      type:String,
      default:()=>''
    }
  },
  data(){
    return {
      authorizationStatues:'UN_AUTH',
      btns:[
        {label:'未授权',value:'UN_AUTH'},
        {label:'已授权',value:'AUTHED'},
        {label:'取消授权',value:'CANCEL'}
      ]
    }
  },
  filters: {
    formatPhoneNumber(phone) {
      return phone.substr(0, 3) + '****' + phone.substr(7)
    }
  },
  methods:{
    handlerChange(val){       
        this.authorizationStatues=val.value;
        this.$emit('handlerChange',val)
    }
  }
}
</script>

<style lang="scss" scoped>
.member-table {
  font-size: 12px;
  $main-color: #004097;
    .tabBtns{
      display: flex;
      justify-content: start;
      line-height: 2em;
      padding-bottom: 1em;
      li{
          padding: 0 1.5em;
      }
      .on{color: #4192ff;}
    }
  .table-header {
    border-radius: 4px 4px 0 0;
    color: #fff;
    background-color: rgba($main-color, 0.5);
    height: 33px;
  }
  .table-data {
    height: 8.5vh;
    color: #323232;
    background-color: rgba($main-color, 0.03);
    border-bottom: 1px solid rgba($main-color, .03);
    &:last-child{
      border-radius: 0 0 4px 4px;
      border-bottom: none;
    }
  }
  .table-row {
    display: flex;
    text-align: center;
    align-items: center;
    .item {
      width: 23%;
      border-left: 1px solid rgba($main-color, .03);
      &:first-child{
        border-left: none;
      }
    }
    .item.email-item {
      width: 31%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .item.btn-item {
      display: flex;
      // align-items: center;
      // justify-content: center;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      height: 100%;
      .auth-btn {
        width: 65px;
        height: 25px;
        line-height: 25px;
        background-color: #1e4998;
        color: #fff;
        font-weight: 600;
        border-radius: 25px;
        display: inline-block;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/share/member-auth/components/MemberTable.vue